import { Component, Injector, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@shared/base/base.component';

@Component({
    selector: 'app-activate',
    templateUrl: './activate.component.html',
    styleUrls: ['./activate.component.scss'],
    standalone: false
})
export class ActivateComponent extends BaseComponent implements OnInit {
  @Input('title') title: any;
  @Input('url') url: any;

  constructor(public override injector: Injector, public modalService: NgbActiveModal) {
    super(injector);
  }

  ngOnInit(): void { }

  confirm() {
    this.httpService
      .PATCH(this.url)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          this.modalService.close(true);
          this.Toastr.success(`'${this.title}' is successfully activated!`);
        },
        err => {
          err.error.forEach(error => {
            this.Toastr.error(error.message);
          });
        }
      );
  }
}
